import { SiteModule } from './site/site.module';
import { ContactService } from './services/contact.service.';
import { ServicesService } from './services/services.service';
import { ServiceRegisterService } from './services/service-register';
import { ServiceCouponsService } from './services/service-coupons';
import { ServiceCalendarService } from './services/service-calendar.service';
import { JwtInterceptor } from './services/auth/jwt.interceptor';
import { ErrorInterceptor } from './services/auth/error.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BlogPostService } from './services/blog-post.service';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';

@NgModule({
  declarations: [
   AppComponent,
  ],
  imports: [SweetAlert2Module.forRoot(),FormsModule,
    BrowserModule,CommonModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,SiteModule,
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/'},
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },

  ],schemas:[NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }
